import magnifiAPIInstance from "./apiInstance";

export const streamPointerAPIs = {
  getStreamPointer: ({ streamId }) => magnifiAPIInstance.get(`/api/v1/stream-pointer/${streamId}`),
  createStreamPointer: (payload) => magnifiAPIInstance.post("/api/v1/stream-pointer", payload),
  updateStreamPointer: ({ pointerId, payload }) =>
    magnifiAPIInstance.put(`/api/v1/stream-pointer/${pointerId}`, payload),
  deleteStreamPointer: ({ pointerId }) => magnifiAPIInstance.delete(`/api/v1/stream-pointer/${pointerId}`),
  getAllStreamPointer: ({ payload }) => magnifiAPIInstance.get(`/api/v1/stream-pointer/get`, payload),
};
